'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'cherries';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = 'M285.6 .1c8.3-.8 16.5 2.7 21.5 9.4L446.8 193.3c5.6-.9 11.3-1.3 17.2-1.3 61.9 0 112 50.1 112 112 0 97.2-86 176-192 176-13.3 0-26.3-1.2-38.8-3.6 52.5-40.5 86.8-101.6 86.8-172.4 0-27.6-7-53.6-19.3-76.3l-120-157.9-62.6 130.3c12.9-5.2 27.1-8.1 41.9-8.1 61.9 0 112 50.1 112 112 0 97.2-86 176-192 176S0 401.2 0 304c0-61.9 50.1-112 112-112 22.2 0 42.9 6.5 60.3 17.6l94.1-196C270 6.1 277.3 1 285.6 .1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;